import { mutationTypes } from '../../../types';

export default store => {
	store.subscribe((mutation, state) => {
		if (state.nearestBeaconAlgorithm.config.isActive && mutation.type === mutationTypes.bluetoothScanStep) {
			store.commit(mutationTypes.nearestBeaconStep, { detectedBeacons: state.bluetooth.detectedBeacons });
		} else if (mutation.type === mutationTypes.setDatasource) {
			const config = Object.assign({}, store.getters.globalConfig.nearestBeaconAlgParameters);
			store.commit(mutationTypes.nearestBeaconSetConfig, config);
		} else if (mutation.type === mutationTypes.setExhibitionID) {
			// TODO Exhibition specifig updating
		}
	});
};
